/** @format */

import { Component, OnInit } from '@angular/core';
import { SideNavModule } from '@shared/components';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'pdp-feature-extremely-low-stock-layer',
	templateUrl: './extremely-low-stock-layer.component.html',
	styleUrl: './extremely-low-stock-layer.component.scss',
	imports: [SideNavModule, HmfButtonComponent]
})
export class ExtremelyLowStockLayerComponent implements OnInit {
	public isSidePanelToggled: boolean;
	public heading = 'EXTREMELY LOW STOCK';

	ngOnInit(): void {
		this.isSidePanelToggled = false;
	}

	displayPanel() {
		this.isSidePanelToggled = !this.isSidePanelToggled;
	}
}
